import React, {FC} from 'react';

interface IType {
    isActive?: boolean
}


export const HomeIcon: FC<IType> = ({isActive}) => {
    return (
        <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M27.9927 11.9766C27.9927 12.8203 27.2634 13.4813 26.437 13.4813H24.8813L24.9153 20.9906C24.9153 21.1172 24.9056 21.2437 24.891 21.3703V22.125C24.891 23.1609 24.0208 24 22.9464 24H22.1686C22.1151 24 22.0616 24 22.0081 23.9953C21.9401 24 21.872 24 21.8039 24H20.2239H19.0572C17.9828 24 17.1126 23.1609 17.1126 22.125V21V18C17.1126 17.1703 16.4174 16.5 15.5569 16.5H12.4455C11.585 16.5 10.8898 17.1703 10.8898 18V21V22.125C10.8898 23.1609 10.0196 24 8.94521 24H7.77844H6.22761C6.15469 24 6.08177 23.9953 6.00884 23.9906C5.95051 23.9953 5.89217 24 5.83383 24H5.05599C3.98159 24 3.11138 23.1609 3.11138 22.125V16.875C3.11138 16.8328 3.11138 16.7859 3.11624 16.7438V13.4813H1.55569C0.680613 13.4813 0 12.825 0 11.9766C0 11.5547 0.145846 11.1797 0.486152 10.8516L12.9511 0.375C13.2914 0.046875 13.6803 0 14.0206 0C14.3609 0 14.7499 0.09375 15.0416 0.328125L27.4579 10.8516C27.8468 11.1797 28.0413 11.5547 27.9927 11.9766Z"/>
        </svg>
    );
};

